import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import { handleError } from "app/redux/errorHandler/errorHandler.saga"
import * as actions from "./planningAvailabilities.actions"

export function* getAvailabilities(action: actions.GetAvailabilitiesAction): SagaIterator {
  try {
    const response = yield call(api.getAvailabilities, action.payload)
    yield put(actions.getAvailabilitiesSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getAvailabilitiesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* planningAvailabilities(): SagaIterator {
  yield takeLatest(actions.Types.GET, getAvailabilities)
}
